// extracted by mini-css-extract-plugin
export default {"Vertical":"Vertical_Vertical__Xv2wo"};